import { motion, AnimatePresence } from "framer-motion";
import { useEffect, useState } from "react";

/*
 * Reusable celebration primitive — a restrained confetti burst.
 * Palette: racing green, near-black, champagne gold. Fires once per `trigger` change.
 */

const COLORS = ["#1D4D3B", "#0A0A0A", "#C9A96A", "#2E7D5B", "#E8E3D9"];
const PIECES = Array.from({ length: 26 }, (_, i) => ({
  id: i,
  x: (i / 26) * 100,
  drift: (i % 5) - 2,
  delay: (i % 7) * 0.05,
  color: COLORS[i % COLORS.length],
  size: 6 + (i % 3) * 3,
}));

export const Celebration = ({ trigger }) => {
  const [burst, setBurst] = useState(0);

  useEffect(() => {
    if (trigger) {
      setBurst((b) => b + 1);
      const id = setTimeout(() => setBurst(0), 2400);
      return () => clearTimeout(id);
    }
    return undefined;
  }, [trigger]);

  return (
    <AnimatePresence>
      {burst > 0 && (
        <div className="fixed inset-0 z-[100] pointer-events-none overflow-hidden" data-testid="celebration-overlay" aria-hidden="true">
          {PIECES.map((p) => (
            <motion.span
              key={`${burst}-${p.id}`}
              initial={{ opacity: 1, y: -20, x: 0, rotate: 0 }}
              animate={{ opacity: [1, 1, 0], y: "105vh", x: p.drift * 60, rotate: p.drift * 220 }}
              transition={{ duration: 2.1, delay: p.delay, ease: [0.22, 1, 0.36, 1] }}
              style={{
                position: "absolute",
                top: 0,
                left: `${p.x}%`,
                width: p.size,
                height: p.size * 1.5,
                backgroundColor: p.color,
                borderRadius: 2,
              }}
            />
          ))}
        </div>
      )}
    </AnimatePresence>
  );
};
